import React, { Component } from 'react'
import moment from 'moment-business-days'

import { AppointmentContainer, Content, DateContainer } from './styles'

class Appointment extends Component {
  render() {
    const { appointment, dashboard } = this.props
    let firstLine = ''
    let secondLine = ''
    if (appointment.week) {
      firstLine = 'Week'
      secondLine = moment(appointment.date).nextBusinessDay().format('dddd') === 'maandag' ? moment(appointment.date).format('ww') + '/' + moment(appointment.date).nextBusinessDay().format('ww') : moment(appointment.date).format('ww')
    } else {
      firstLine = moment(appointment.date).format('dddd')
      secondLine = moment(appointment.date).format('DD MMM')
    }

    if (appointment.empty) {
      return <AppointmentContainer dashboard={dashboard} empty />
    }

    return (
      <AppointmentContainer dashboard={dashboard}>
        <DateContainer dashboard={dashboard}>
          <div>{firstLine}</div>
          <div>{secondLine}</div>
        </DateContainer>

        <Content dashboard={dashboard}>
          {appointment.content}
          <span>{appointment.subtitle}</span>
        </Content>
      </AppointmentContainer>
    )
  }
}

export default Appointment



// WEBPACK FOOTER //
// ./src/components/Appointment/index.js